import React from "react";

const services = [
	"IT Infrastructure Deployment",
	"Smart Building Solutions",
	"Real Estate and Construction",
	"Software Development",
	"Energy and Sustainability Consulting",
];

const Services = () => (
	<section id="services" className="bg-gray-100 py-16 px-6">
		<div className="max-w-5xl mx-auto">
			<h3 className="text-3xl font-bold text-red-500 mb-8">Our Services</h3>
			<ul className="grid md:grid-cols-2 gap-6">
				{services.map((s, i) => (
					<li key={i} className="bg-white p-4 border-l-4 border-red-500 shadow">
						{s}
					</li>
				))}
			</ul>
		</div>
	</section>
);

export default Services;
